// @generated by TypeGen from LogbookServer/AccountApi.swift - DO NOT EDIT

import type { IAccountSearchRequest, IAccountSubscriptionPlanInfo, IAccountSubscriptionPlansResponse } from "../LogbookApi/AccountApi"
import type { IAccountSearchResponse } from "../LogbookModel/Account"
import { IAccountUserLevel } from "../LogbookModel/AccountUser"
import type { ISessionResponse } from "../LogbookModel/Session"
import type { IUser } from "../LogbookModel/User"
import type { ISuccessResponse } from "./SuccessResponse"

export interface IAccountUserInfo {
  level: IAccountUserLevel;
  status: IAccountUserStatus;
  user: IUser;
  hasShipAccess: boolean;
}

export interface IAccountSignupRequest {
  name: string;
  email: string;
  password: string;
  accountName?: string;
  language?: string;
}

export interface IAccountUserLevelRequest {
  accountLevel: IAccountUserLevel;
}

export interface IAccountUserUpdateLanguageRequest {
  language: string;
}

export interface IAccountUserUpdatePasswordRequest {
  oldPassword: string;
  password: string;
  passwordConfirmation: string;
}

export interface IAccountUserUpdateRequest {
  accountName: string;
  name: string;
  shortname: string;
}

export interface IAccountInvitationResponse {
  account: string;
  email: string;
  inviter: string;
  name: string;
  ship: string;
}

export interface IAccountUsersResponse {
  users: IAccountUserInfo[];
}

export enum IAccountUserStatus {
  invited = "invited",
  active = "active",
}

export interface AccountApiServerEndpoints {
  "DELETE /api/account": {
    params: {};
    query: {};
    request: never;
    response: ISuccessResponse;
    permission: { account: IAccountUserLevel };
  };
  "DELETE /api/account/users/:userId": {
    params: { userId: number };
    query: {};
    request: never;
    response: ISuccessResponse;
    permission: { account: IAccountUserLevel };
  };
  "GET /api/account/plan": {
    params: {};
    query: {};
    request: never;
    response: IAccountSubscriptionPlanInfo;
    permission: { account: IAccountUserLevel };
  };
  "GET /api/account/plans": {
    params: {};
    query: {};
    request: never;
    response: IAccountSubscriptionPlansResponse;
    permission: { session: true };
  };
  "GET /api/account/users": {
    params: {};
    query: {};
    request: never;
    response: IAccountUsersResponse;
    permission: { account: IAccountUserLevel };
  };
  "GET /api/signup/invitation/:token": {
    params: { token: string };
    query: {};
    request: never;
    response: IAccountInvitationResponse;
    permission: {};
  };
  "POST /api/account": {
    params: {};
    query: {};
    request: IAccountSignupRequest;
    response: ISuccessResponse;
    permission: {};
  };
  "POST /api/search": {
    params: {};
    query: {};
    request: IAccountSearchRequest;
    response: IAccountSearchResponse;
    permission: { account: IAccountUserLevel };
  };
  "POST /api/signup/confirm-email/:token": {
    params: { token: string };
    query: {};
    request: never;
    response: ISessionResponse;
    permission: {};
  };
  "POST /api/signup/invitation/:token": {
    params: { token: string };
    query: {};
    request: IAccountSignupRequest;
    response: ISessionResponse;
    permission: {};
  };
  "PUT /api/account/user": {
    params: {};
    query: {};
    request: IAccountUserUpdateRequest;
    response: ISessionResponse;
    permission: { session: true };
  };
  "PUT /api/account/user/language": {
    params: {};
    query: {};
    request: IAccountUserUpdateLanguageRequest;
    response: ISessionResponse;
    permission: { session: true };
  };
  "PUT /api/account/user/password": {
    params: {};
    query: {};
    request: IAccountUserUpdatePasswordRequest;
    response: ISessionResponse;
    permission: { session: true };
  };
  "PUT /api/account/users/:userId": {
    params: { userId: number };
    query: {};
    request: IAccountUserLevelRequest;
    response: ISuccessResponse;
    permission: { account: IAccountUserLevel };
  };
}

export const accountApiServerEndpoints = {
  "DELETE /api/account": { permission: { account: IAccountUserLevel.admin } },
  "DELETE /api/account/users/:userId": { permission: { account: IAccountUserLevel.admin } },
  "GET /api/account/plan": { permission: { account: IAccountUserLevel.user } },
  "GET /api/account/plans": { permission: { session: true } },
  "GET /api/account/users": { permission: { account: IAccountUserLevel.admin } },
  "GET /api/signup/invitation/:token": { permission: {} },
  "POST /api/account": { permission: {} },
  "POST /api/search": { permission: { account: IAccountUserLevel.user } },
  "POST /api/signup/confirm-email/:token": { permission: {} },
  "POST /api/signup/invitation/:token": { permission: {} },
  "PUT /api/account/user": { permission: { session: true } },
  "PUT /api/account/user/language": { permission: { session: true } },
  "PUT /api/account/user/password": { permission: { session: true } },
  "PUT /api/account/users/:userId": { permission: { account: IAccountUserLevel.admin } },
} as const;
